import React from 'react';

const LockIcon = ({ ...props }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.20065 6.38271C7.70471 5.88698 7.03219 5.60849 6.33096 5.60849C5.62974 5.60849 4.95722 5.88698 4.46127 6.38271L2.59098 8.2524C2.09503 8.74835 1.81641 9.42101 1.81641 10.1224C1.81641 10.8238 2.09503 11.4964 2.59098 11.9924C3.08693 12.4883 3.75959 12.767 4.46097 12.767C5.16235 12.767 5.83501 12.4883 6.33096 11.9924L7.26581 11.0575"
      stroke="currentColor"
      strokeWidth="1.21094"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33203 8.25212C6.82797 8.74785 7.50049 9.02634 8.20172 9.02634C8.90294 9.02634 9.57546 8.74785 10.0714 8.25212L11.9417 6.38243C12.4377 5.88648 12.7163 5.21382 12.7163 4.51244C12.7163 3.81106 12.4377 3.1384 11.9417 2.64245C11.4457 2.1465 10.7731 1.86787 10.0717 1.86787C9.37033 1.86787 8.69767 2.1465 8.20172 2.64245L7.26687 3.57729"
      stroke="currentColor"
      strokeWidth="1.21094"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockIcon;
